// Canvas Zenith (`components/ListToolbar.tsx`): barra de filtros/abas acima de uma lista,
// filtros/controles à esquerda (`children`), resumo muted à direita. Reusar em vez de
// recriar o flex row em cada tela com lista (transações, saldo, saques).

import type { ReactNode } from 'react';
import { cn } from '../../lib/cn.ts';

export function ListToolbar({
  children,
  right,
  className,
}: {
  children: ReactNode;
  right?: ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-center justify-between gap-2.5', className)}>
      <div className="flex min-w-0 flex-1 flex-wrap items-center gap-2.5">{children}</div>
      {right !== undefined && (
        <span className="shrink-0 text-xs text-muted-foreground tabular-nums">{right}</span>
      )}
    </div>
  );
}
